/* Language preferences use Shopify's published URLs. Country/currency remain in Markets.
   Explicit localized links win; a manual language selection is remembered on this device. */
(() => {
  const KEY = 'pradem-preferred-language';
  function preferredLanguage(languages, saved, browserLanguages, country) {
    const supported = (value) => languages.find(item => item.code.toLowerCase() === String(value || '').toLowerCase())
      || languages.find(item => item.code.split('-')[0] === String(value || '').toLowerCase().split('-')[0]);
    if (saved && supported(saved)) return supported(saved);
    const local = { PL:'pl', DE:'de', AT:'de', FR:'fr' }[country];
    const browser = browserLanguages.map(supported).find(Boolean);
    // English is often an OS default. For PL/DE/FR, use the local language unless
    // the visitor explicitly selected English or prefers another translated language.
    if (browser && browser.code.split('-')[0] !== 'en') return browser;
    return supported(local) || browser || languages.find(item => item.primary) || supported('en') || languages[0];
  }
  function localizedPath(path, language) {
    const root = (language.root || '').replace(/\/$/, '');
    return root + (path === '/' ? '' : path) || '/';
  }
  const config = document.getElementById('pradem-language-config');
  if (!config) return;
  let data;
  try { data = JSON.parse(config.textContent); } catch { return; }
  if (data.editor || !data.languages?.length) return;
  const remember = (code) => {
    if (!data.languages.some(item => item.code === code)) return;
    try { localStorage.setItem(KEY, code); } catch { /* Native localization still works. */ }
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="locale_code"]');
    if (button) remember(button.value);
    const link = event.target.closest('localization-form a[data-value]');
    const form = link?.closest('form');
    if (form?.querySelector('input[name="locale_code"]') && !form.querySelector('input[name="country_code"]')) remember(link.dataset.value);
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('select[name="locale_code"]')) remember(event.target.value);
  });
  // Search engines and their testing tools must keep the language URL they inspect.
  if (/bot|crawler|spider|slurp|bingpreview|facebookexternalhit|google-inspectiontool/i.test(navigator.userAgent)) return;
  const url = new URL(location.href);
  try {
    if (sessionStorage.getItem('pradem-language-attempt') === url.pathname) sessionStorage.removeItem('pradem-language-attempt');
  } catch { /* No storage. */ }
  if (/^\/(?:cart|checkout|checkouts|account|customer_authentication|challenge|password|localization)(?:\/|$)/.test(url.pathname)) return;
  if (url.searchParams.has('locale') || url.searchParams.has('language')) return;
  if (data.languages.some(item => item.root && item.root !== '/' && (url.pathname === item.root || url.pathname.startsWith(item.root + '/')))) return;
  let saved;
  try { saved = localStorage.getItem(KEY); } catch { /* Browser and market fallback. */ }
  const target = preferredLanguage(data.languages, saved, navigator.languages || [navigator.language], data.country);
  if (!target || target.code === data.current) return;
  const path = localizedPath(url.pathname, target);
  if (path === url.pathname) return;
  // Avoid repeated navigation if a published locale is temporarily unavailable.
  try {
    if (sessionStorage.getItem('pradem-language-attempt') === path) return;
    sessionStorage.setItem('pradem-language-attempt', path);
  } catch { return; }
  url.pathname = path;
  location.replace(url.href);
})();
